<!-- 搜索单元 -->
<template>
  <div class='searchWard'>
    <div class="header df-between" :style="{'padding-top':utils.isIphoneX()?'50px':'30px'}">
      <img src="../../assets/images/i-arrow-left.png" alt="" @click='handleBack' >
      <div class="title">选择单元</div>
      <span></span>
    </div>
    <div class="container">
      <div class="search-box">
        <img src="../../assets/images/iv_search.png" alt="">
        <input type="text" v-model='searchName' @blur='handleChange' @input='handleChange' placeholder="输入关键字搜索">
      </div>
      <div class="empty" v-if='isEmpty'>
        <img src="../../assets/images/notAuditRecord.png" alt="">
        <span>未搜索到相关物理单元</span>
      </div>
      <div class="item" v-else v-for='(item,index) in searchData' @click='handleConfirmDept(item)' :key='index'>
        {{item.name2}}-{{item.name1}}
      </div>
      
    </div>
  </div>
</template>

<script>
  export default {
    props:['deptData','tabIndex','totalWardNumber','relevanceNumber'],
    data() {
      return {
        searchName:'',
        isEmpty:true,
        searchData:[]
      }
    },
    created() {
    },
    methods: {
      handleConfirmDept(val){
        if(this.totalWardNumber.length>this.relevanceNumber-1){
          this.$toast('最多只能关联'+this.relevanceNumber+'个单元');
        }else{
          this.$emit('conFirmSearchDept',val)
        }
      },
      handleSearchReset(){
        this.isEmpty = true
        this.searchData = []
        this.searchName = ''
      },
      handleChange(){
        console.log(this.deptData,'this.deptData');
        this.searchData = []
        console.log(this.tabIndex,'tabIndex');
        console.log(this.searchName,'searchName');
        var str = this.searchName
        var reg = RegExp(str,'g')
        if(this.searchName){
          this.deptData.forEach((x,y)=>{
            x.children.forEach((v,i)=>{
              console.log(v,'vvvv');
              v.children.forEach((v1,i1)=>{
                console.log(v1,'vvvv111111');
                v1.wards.forEach((v2,i2)=>{
                  console.log(v2,'vvvv222222');
                  if(reg.test(v1.name)||reg.test(v2.inpatientArea)){
                    this.searchData.push({index:y,index1:i,index2:i1,index3:i2,name1:v1.name,name2:v2.inpatientArea,id:v2.id})
                  }
                })
              })
            })
          })
        }
        console.log(this.searchData,'searchData');
        if(this.searchData.length>0){
          this.isEmpty = false
        }
      },
      handleBack(){
        this.$emit('handlleCloseSearchWard')
      }
    },
  }
</script>
<style lang='scss' scoped>
  .searchWard {
    display: flex;
    flex-direction: column;
    height: 100vh;
    .header {
      padding: 15px 15px 15px 5px;
      border-bottom: 1px solid #f2f2f2;
      color: #000;
      img {
        width: 22px;
        height: 22px;
      }
      .title {
        font-size: 17px;
      }
    }
  }

  .container{
    overflow: scroll;
    .search-box{
      position: relative;
      padding: 15px 12px;
      background-color: #fff;
      img{
        position: absolute;
        top: 50%;
        left: 24px;
        transform: translateY(-50%);
        width: 16px;
        height: 16px;
      }
      input{
        width: 100%;
        text-indent: 30px;
        height: 30px;
        opacity: 1;
        border: 1px solid #e5e5e5;
        border-radius: 31px;
        font-size: 14px;
        background-color: #f2f2f2;
      }
    }
    .item{
      padding: 10px 0px;
      // // height: 44px;
      // line-height: 44px;
      margin-left: 25px;
      padding-right: 12px;
      border-bottom: 1px solid #eee;
      font-family: PingFang, PingFang-SC;
      font-weight: SC;
      color: #404040;
      font-size: 14px;
    }
    .empty{
      display: flex;
      flex-direction: column;
      align-items: center;
      img{
        margin: 80px 0px 20px;
        width: 250px;
        height: 180px;
      }
      span{
        font-size: 16px;
        font-family: PingFang, PingFang-SC;
        font-weight: SC;
        text-align: center;
        color: #999999;
      }
    }
  }
</style>